import React from "react";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
} from "@tanstack/react-table";
import classes from "./table.module.css";

export const Table = ({ data, columns, mobileHiddenColumns = [] }) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className={classes.box}>
      <div className={classes.box__table}>
        <table className={classes.box__modelTable}>
          <thead className={classes.box__modelTable__head}>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  const hideClass = mobileHiddenColumns.includes(
                    header.column.id
                  )
                    ? classes.hideMobile
                    : "";

                  return (
                    <th
                      key={header.id}
                      className={`${classes.box__modelTable__head__row__cell} ${hideClass}`}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody>
            {data.length > 0 ? (
              table.getRowModel().rows.map((row, i) => (
                <tr
                  key={row.id}
                  className={classes.box__modelTable__body__row}
                  style={{
                    backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#ffffff",
                  }}
                >
                  {row.getVisibleCells().map((cell) => {
                    const hideClass = mobileHiddenColumns.includes(
                      cell.column.id
                    )
                      ? classes.hideMobile
                      : "";

                    return (
                      <td
                        key={cell.id}
                        className={`${classes.box__modelTable__body__row__data} ${hideClass}`}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className={classes.box__modelTable__body__row__data__empty}
                >
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

